module.exports = __webpack_public_path__ + "static/media/brand-refresh-expand-icon.a9d86b27.svg";